import React from 'react';
import styled from 'styled-components';
import { Parallax } from 'react-scroll-parallax';
import HeroBackground from './HeroBackground';

const StyledWrap = styled.div`
  position: relative;
  overflow: hidden;
`;

export default function () {
  return (
    <StyledWrap>
      <Parallax offsetYMin={'-20%'} offsetYMax={'20%'} slowerScrollRate>
        <HeroBackground />
      </Parallax>
    </StyledWrap>
  );
}



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/ParallaxBanner.js